var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.5h7c2.55 0 4 1.45 4 4v7c0 2.55-1.45 4-4 4h-7c-2.55 0-4-1.45-4-4v-7c0-2.55 1.45-4 4-4Zm3.54 11.9c.32 0 .59-.24.62-.57V5.2a.61.61 0 0 0-.28-.6.63.63 0 0 0-.97.6v7.64c.04.33.31.57.63.57Zm3.45 0c.31 0 .58-.24.62-.57v-2.46a.63.63 0 0 0-.96-.6.6.6 0 0 0-.28.6v2.46c.03.33.3.57.62.57Zm-6.33-.57a.62.62 0 0 1-.62.57.62.62 0 0 1-.62-.57V7.65a.63.63 0 0 1 .3-.6c.2-.12.45-.12.65 0 .2.14.32.37.3.6v5.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartmedium);
export default __webpack_public_path__ + "static/media/chart.medium.41c0c7b45870b9acfd2b906f1a93f86d.svg";
export { ForwardRef as ReactComponent };